module.exports = __webpack_public_path__ + "static/email_icon.3568bfbe.jpg";